export function formatMoney(s: string) {
  return parseFloat(s).toFixed(2)
}

export function formatMoneyWithCurrency(s: string) {
  return `£${formatMoney(s)}`
}
